// FILECONTENT_START src/common/modules/notifications/useNotifications.ts
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useEffect } from "react";
// Import the functions you need from the SDKs you need
import { FirebaseError, initializeApp } from "firebase/app";
import I18n from "i18n-js";
import { globalMessageHandler } from "./../../components/GlobalMessaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DBURL,
  projectId: process.env.REACT_APP_FIREBASE_PRFOJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGESENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
};

let isFirebaseEnabled: boolean = false;

if (
  process.env.REACT_APP_FIREBASE_APIKEY &&
  process.env.REACT_APP_FIREBASE_AUTHDOMAIN &&
  process.env.REACT_APP_FIREBASE_DBURL &&
  process.env.REACT_APP_FIREBASE_PRFOJECTID &&
  process.env.REACT_APP_FIREBASE_STORAGEBUCKET &&
  process.env.REACT_APP_FIREBASE_MESSAGESENDERID &&
  process.env.REACT_APP_FIREBASE_APPID &&
  (window.location.href.includes("localhost") ||
    window.location.href.includes("https"))
) {
  isFirebaseEnabled = true;
}
// Initialize Firebase
export let firebaseApp: any = null;

if (isFirebaseEnabled) {
  firebaseApp = initializeApp(firebaseConfig);
}

let messaging: any;
if (isFirebaseEnabled) {
  try {
    messaging = getMessaging(firebaseApp);
  } catch (error) {}
}

export interface GetFirebaseTokenProps {
  onChange?: (token: string) => void;
}
export async function getFirebaseToken({ onChange }: GetFirebaseTokenProps) {
  let fcmToken: string | undefined = undefined;
  if (!isFirebaseEnabled) {
    console.log("NINCS");
    return null;
  }
  try {
    console.log("START OKEN GET");
    fcmToken = await getToken(messaging, {
      vapidKey:
        "BN6BZfb6-UWzZlBHvzcIi_s6pxzrf4whJE6yhaTxNoPPLa_P173FbC-5RpwPD3_oTVbThMr4bfoCAvuc1Xldw_U",
    });
    console.log("TOKEN READY:", fcmToken);
  } catch (error) {
    //blocked
    if ((error as FirebaseError).code === "messaging/permission-blocked") {
      const notificationBlockPopped = sessionStorage.getItem(
        "notificationBlockPopped"
      );
      if (notificationBlockPopped !== "1") {
        sessionStorage.setItem("notificationBlockPopped", "1");
        globalMessageHandler.error(
          I18n.t("App.notificationsBlocked", {
            default: (error as FirebaseError).message,
          }),
          undefined,
          undefined,
          {
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            style: { cursor: "pointer" },
            autoHideDuration: 10000,
          }
        );
      }
    }
  }

  const oldFcmToken = localStorage.getItem("fcmToken");
  if (fcmToken && fcmToken !== oldFcmToken) {
    localStorage.setItem("fcmToken", fcmToken);
    onChange && onChange(fcmToken);
    return fcmToken;
  }
  return oldFcmToken;
}

/*function onMessageListener() {
  return new Promise(resolve => {
    onMessage(messaging, payload => {
      
      resolve(payload);
    });
  });
}*/

export interface UseNotificationsProps {
  onTokenChange?: (token: string) => void;
  onNotification?: (notification: any) => void;
  disabled?: boolean;
}

export default function useNotifications({
  onTokenChange,
  onNotification,
  disabled,
}: UseNotificationsProps) {
  useEffect(() => {
    if (isFirebaseEnabled && !disabled) {
      getFirebaseToken({
        onChange: token => {
          onTokenChange && onTokenChange(token);
        },
      });
      const unsubscribe = onMessage(messaging, payload => {
        console.log("ON MESDSAGE");
        onNotification && onNotification(payload);
      });
      return () => unsubscribe();
      /*onMessageListener()
        .then(async (payload: any) => {
          onNotification && onNotification(payload);
        })
        .catch(err => console.log("failed: ", err));*/
    }
  }, [disabled]);

  /*onMessageListener()
    .then(async (payload: any) => {
      
      const url = payload.fcmOptions?.link;

      await dispatch(loadNotificationsAsync({} as any));
      await dispatch(loadNotificationCountAsync());

      globalMessageHandler.info(
        payload.notification.body,
        payload.notification.title,
        () => console.log(url),
        {
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          style: { cursor: "pointer" },
          autoHideDuration: 5000,
        }
      );
    })
    .catch(err => console.log("failed: ", err));*/
}

/*
curl -X POST -H "Authorization: Bearer YOUR-TOKEN" -H "Content-Type: application/json" -d '{
  "message":{
    "token":"emy159ZFwFa46rfN8QA9jj:APA91bEymmko02RTHRglOXHmQUi0KB5rB7tZJyfVK8m6p2nmg91YDZ3bcXBeeIXEmEZebU-ESopT1YFCoE4rVpkS8O-leJbZCgESFs45Vo2zpZ3g_sO0C26gYDBVflQV1DaPUCkA1jQw",
    "notification":{
      "title":"Hello",
      "body":"This is a text message!"
    }
  }
}' https://fcm.googleapis.com/v1/projects/culinary-2d547/messages:send
*/

// FILECONTENT_END src/common/modules/notifications/useNotifications.ts
